(function () {
  if (window.hkMeasure) return;
  const allowedEvents = new Set(['hk:offer_request_clicked', 'hk:whatsapp_opened', 'hk:whatsapp_clicked', 'hk:inquiry_submit_attempted', 'hk:inquiry_submitted']);
  window.hkMeasure = function (eventName, data) {
    try {
      const shopify = window.Shopify;
      if (!allowedEvents.has(eventName) || !shopify?.customerPrivacy?.analyticsProcessingAllowed() || !shopify?.analytics?.publish) return false;
      const payload = {};
      ['product_handle', 'variant_id', 'inquiry_type', 'quantity', 'method'].forEach(key => {
        if (data?.[key] != null) payload[key] = String(data[key]).slice(0, 160);
      });
      const result = shopify.analytics.publish(eventName, payload);
      if (result?.catch) result.catch(function () {});
      return true;
    } catch (_) { return false; }
  };
  const pendingKey = 'hk:project_inquiry_pending';
  let confirmed = false;
  function publishConfirmedInquiry() {
    if (confirmed || !document.querySelector('[data-hk-inquiry-confirmed]')) return;
    try {
      const submittedAt = Number(window.sessionStorage.getItem(pendingKey));
      const age = Date.now() - submittedAt;
      if (!submittedAt || age < 0 || age > 1800000) return;
      confirmed = window.hkMeasure('hk:inquiry_submitted', {method: 'contact_form'}) === true;
      if (confirmed) window.sessionStorage.removeItem(pendingKey);
    } catch (_) {}
  }
  document.addEventListener('DOMContentLoaded', publishConfirmedInquiry);
  document.addEventListener('visitorConsentCollected', publishConfirmedInquiry);
  if (document.readyState !== 'loading') publishConfirmedInquiry();
  if (window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) { if (!error) publishConfirmedInquiry(); });
  }
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="contact[email]"]') || !form.querySelector('[name="contact[body]"]') || !form.checkValidity()) return;
    const recorded = window.hkMeasure('hk:inquiry_submit_attempted', {method: 'contact_form'});
    if (form.id === 'hk-project-form' && recorded) {
      try { window.sessionStorage.setItem(pendingKey, String(Date.now())); } catch (_) {}
    }
  }, true);
})();
